export default __webpack_public_path__ + "static/media/brutalenragingstrike2.056fcb17.png";